import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  loading: boolean = false;
  public static loadingV: Subject<any> = new Subject();
  constructor() { }

  ngAfterViewInit() {
    LoaderComponent.loadingV.subscribe(res => {
      this.loading = res;
    });

  }

  ngOnChanges() {
    LoaderComponent.loadingV.subscribe(res => {
      this.loading = res;
    });
  }
  ngOnInit () {

  }

}



// WEBPACK FOOTER //
// ./src/app/loader/loader.component.ts